import { takeEvery, put } from 'redux-saga/effects';
import {
  ACT_TAGS_FETCH_INIT,
} from '../constants/actions';
import {
  fetchTagsSuccessAction,
} from '../actions/tagsActions';
import Api from '../services/Api';

function* fetchTags() {
  const { status, data } = yield Api.get('tags?per_page=100', false);
  if (status === 200) {
    yield put(fetchTagsSuccessAction(data.data));
  }
}

function* tagsSagas() {
  yield takeEvery(ACT_TAGS_FETCH_INIT, fetchTags);
}

export default tagsSagas;
